<div class="loader">
  <div class="stage">

    <div class="floor-shadow"></div>
    <div class="impact"></div>
    <div class="puff"></div>
    <div class="puff"></div>
    <div class="puff"></div>

    <div class="hammer">
      <svg viewBox="0 0 96 50" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="headWood" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#a5713e" />
            <stop offset="45%" stop-color="#8a5a30" />
            <stop offset="100%" stop-color="#5e3c1f" />
          </linearGradient>
          <linearGradient id="handleWood" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#c98a4b" />
            <stop offset="50%" stop-color="#a8703a" />
            <stop offset="100%" stop-color="#7a4e26" />
          </linearGradient>
          <linearGradient id="bandGold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#f0555a" />
            <stop offset="50%" stop-color="#E31E24" />
            <stop offset="100%" stop-color="#a3151a" />
          </linearGradient>
        </defs>

        <!-- handle, tapered with rounded end -->
        <path d="M40 22 L88 25.5 Q92 26 92 28.5 Q92 31 88 31.5 L40 30 Z" fill="url(#handleWood)" stroke="var(--ink)"
          stroke-width="1.4" stroke-linejoin="round" />
        <path d="M44 24.4 L86 27.4" stroke="rgba(0,0,0,.25)" stroke-width="1" stroke-linecap="round" />
        <ellipse cx="90" cy="28.5" rx="2.6" ry="3" fill="#7a4e26" stroke="var(--ink)" stroke-width="1.1" />

        <!-- cylindrical head, drawn as a barrel: two end caps + body -->
        <rect x="8" y="4" width="30" height="36" rx="3" fill="url(#headWood)" stroke="var(--ink)" stroke-width="1.8" />
        <ellipse cx="9.5" cy="22" rx="3.2" ry="18" fill="#6b4423" stroke="var(--ink)" stroke-width="1.4" />
        <ellipse cx="36.5" cy="22" rx="3.2" ry="18" fill="#9c6a3a" stroke="var(--ink)" stroke-width="1.4" />

        <!-- gold ferrule bands -->
        <rect x="14" y="4" width="5" height="36" fill="url(#bandGold)" stroke="var(--ink)" stroke-width="1" />
        <rect x="27" y="4" width="5" height="36" fill="url(#bandGold)" stroke="var(--ink)" stroke-width="1" />

        <!-- soft top highlight -->
        <rect x="10" y="5.5" width="26" height="4" rx="2" fill="#fff" opacity=".18" />
      </svg>
    </div>

    <svg class="block" style="position:absolute; left:50%; bottom:18px; width:64px; transform:translateX(-50%);"
      viewBox="0 0 64 14" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="blockWood" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#8a5a30" />
          <stop offset="100%" stop-color="#4f3018" />
        </linearGradient>
      </defs>
      <ellipse cx="32" cy="9" rx="31" ry="4.6" fill="url(#blockWood)" stroke="var(--ink)" stroke-width="1.6" />
      <path d="M2 9 Q32 13.5 62 9" stroke="rgba(0,0,0,.3)" stroke-width="1" fill="none" />
      <rect x="6" y="8.6" width="52" height="4.6" fill="#3d2412" opacity=".9" />
      <ellipse cx="32" cy="9" rx="31" ry="4.6" fill="none" stroke="rgba(0,0,0,.35)" stroke-width="1" />
    </svg>
  </div>

  <p class="loader__text">Bidding...</p>
</div>